import { useState, useEffect, useContext, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";

import Avatar from "@mui/material/Avatar";

import DataTable from "examples/Tables/DataTable";

import qs from "query-string";
import api from "services/api";
import toast from "react-hot-toast";
import moment from "moment";

import SharedContentContext from "context/shared-content";
import { AccountContext } from "context/account";

import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import { Empty } from "antd";

import { compare } from "utils/helper";
import Tooltip from "@mui/material/Tooltip";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

const avatarSize = 26;

const SharedMoodboardList = ({ size = 60, limit, tableOptions = {} }) => {
  const [moodboards, setMoodboards] = useState([]);
  const [filteredMoodboards, setFilteredMoodboards] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState({});

  const location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);

  const { resourceList } = useContext(SharedContentContext);

  const navigate = useNavigate();

  useEffect(() => {
    retrieveMoodboards();
  }, [resourceList]);

  const retrieveMoodboards = async () => {
    try {
      const { data } = await api.moodboard.sharedList();
      let myMoodboard = data?.moodboards || [];
      const sharedToAllIds = resourceList
        .filter((x) => x.user_id == "AllDesigners")
        .map((x) => x.resource_id);
      myMoodboard = myMoodboard.filter((x) => sharedToAllIds.includes(x.id));
      myMoodboard = myMoodboard.sort((a, b) => compare(a, b, "-updated_at"));
      if (limit) {
        myMoodboard = myMoodboard.slice(0, limit);
      }

      setMoodboards(myMoodboard);
      setFilteredMoodboards(myMoodboard);
    } catch (err) {
      toast.error(`Retrieve moodboards for collection:${detail["title"]} failed!`);
      console.log(err);
    }
  };

  return (
    <SuiBox>
      <SuiBox sx={{ overflow: "auto" }}>
        {filteredMoodboards.length > 0 ? (
          <ResponsiveMasonry columnsCountBreakPoints={{ 300: 1, 550: 2, 850: 3, 1200: 4, 1400: 5 }}>
            <Masonry gutter="16px">
              {filteredMoodboards.map((mb) => (
                <SuiBox>
                  <div>
                    <SuiBox
                      onClick={(e) => {
                        navigate(`/shared-with-me/moodboards?id=${mb.id}`);
                      }}
                      sx={{
                        cursor: "pointer",

                        overflow: "hidden",
                        position: "relative",
                        display: "flex",
                        minWidth: 0,
                        width: "100%",
                        height: 234,
                      }}
                      className="hover-parent"
                    >
                      <ImageCardWrapper
                        data={mb?.img}
                        height={234}
                        width={"100%"}
                        draggable={false}
                        resizeType="m_lfit"
                        className="object-fit"
                      />
                      <SuiBox className="overlay">
                        <SuiBox display="flex" alignItems="center" gap={1}>
                          <SuiTypography
                            variant="body1"
                            textTransform="none"
                            color="white"
                            sx={{
                              fontWeight: "bold",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: "2",
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {mb?.name}
                          </SuiTypography>{" "}
                        </SuiBox>
                      </SuiBox>
                    </SuiBox>
                  </div>

                  <SuiBox sx={{ my: 0.5, px: 1 }}>
                    <SuiBox display="flex" justifyContent="space-between" alignItems="center">
                      <SuiBox>
                        <SuiTypography
                          variant="body1"
                          textTransform="none"
                          color="dark"
                          sx={{
                            fontWeight: "bold",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: "2",
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {mb?.name}
                        </SuiTypography>
                      </SuiBox>
                    </SuiBox>
                  </SuiBox>
                </SuiBox>
              ))}
            </Masonry>
          </ResponsiveMasonry>
        ) : (
          <Empty />
        )}
      </SuiBox>
    </SuiBox>
  );
};

export default SharedMoodboardList;
